/* eslint-disable import/prefer-default-export */
export const GET_CUSTOMER_REVENUE = 'GET_CUSTOMER_REVENUE';
